module.exports = __webpack_public_path__ + "img/phone1.e784dd5d.png";